import { Routes } from '../navigation/config/routes'

const LOGIN_NEXT_KEY = 'ezos_login_next'

export const isSafeNextPath = (path?: string | null) =>
    Boolean(path && path.startsWith('/') && !path.startsWith('//'))

export const storeLoginNext = (path?: string | null) => {
    if (typeof window === 'undefined' || !isSafeNextPath(path)) {
        return
    }
    sessionStorage.setItem(LOGIN_NEXT_KEY, path as string)
}

export const consumeLoginNext = () => {
    if (typeof window === 'undefined') {
        return null
    }
    const next = sessionStorage.getItem(LOGIN_NEXT_KEY)
    sessionStorage.removeItem(LOGIN_NEXT_KEY)
    return isSafeNextPath(next) ? next : null
}

export const defaultPostLoginRoute = (companyType?: string) =>
    companyType === 'APARTMENT'
        ? Routes.apartment.schedule.root
        : Routes.vendor.ezwork

export const resolvePostLoginRoute = (companyType?: string) =>
    consumeLoginNext() || defaultPostLoginRoute(companyType)
